import { lazy, Suspense } from 'react';

const LoginForm = lazy(() =>
  import('@repo/ui/components/containers/login/login-form').then((mod) => ({ default: mod.default })),
);

export default function AuthLandingPage() {
  return (
    <Suspense fallback={<div className="flex items-center justify-center h-screen">Loading...</div>}>
      <LoginForm />
    </Suspense>
  );
}
